/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Icon_HintInputs */



/**
* | output |
* | --- |
* | "Optional. Without one, the agent shows the default avatar." |
*
* @param {Agent_Builder_Icon_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_icon_hint = /** @type {((inputs?: Agent_Builder_Icon_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Icon_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Optional. Ohne Symbol zeigt der Agent den Standard-Avatar.")
	return /** @type {LocalizedString} */ ("Optional. Without one, the agent shows the default avatar.")
});